import React, { createContext, useContext, useState } from "react";
import ConfirmModal from "../Modal/ConfirmModal";

type ConfirmColorType = "blue" | "red" | "green" | "yellow";
interface ModalContextType {
    openModal: (
        title: string,
        message: string,
        onConfirm: () => void,
        isShowCancel?: boolean,
        confirmText?: string,
        cancelText?: string,
        confirmColor?: "blue" | "red" | "green" | "yellow",
    ) => void;
    closeModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    const [onModalConfirm, setOnModalConfirm] = useState<() => void>(() => () => { });
    const [showCancel, setShowCancel] = useState(true);

    const [confirmText, setConfirmText] = useState<string>("Confirm");
    const [cancelText, setCancelText] = useState<string>("Cancel");
    const [confirmColor, setConfirmColor] = useState<ConfirmColorType>("blue");

    const openModal = (
        title: string,
        message: string,
        onConfirm: () => void,
        isShowCancel: boolean = true,
        confirmText: string = "Confirm",
        cancelText: string = "Cancel",
        confirmColor: ConfirmColorType = "blue",

    ) => {
        setModalTitle(title);
        setModalMessage(message);
        setOnModalConfirm(() => onConfirm);
        setModalOpen(true);
        setShowCancel(isShowCancel);
        setConfirmText(confirmText);
        setCancelText(cancelText);
        setConfirmColor(confirmColor);

    };

    const closeModal = () => setModalOpen(false);

    return (
        <ModalContext.Provider value={{ openModal, closeModal }}> {/* ✅ include closeModal */}
            {children}
            <ConfirmModal
                isOpen={modalOpen}
                title={modalTitle}
                message={modalMessage}
                onCancel={closeModal}
                onConfirm={() => {
                    onModalConfirm();
                    closeModal();
                }}
                confirmText={confirmText}
                cancelText={cancelText}
                showCancel={showCancel}
                confirmColor={confirmColor}
            />
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) throw new Error("useModal must be used inside ModalProvider");
    return context;
};